import React from 'react'
import { inject, observer } from 'mobx-react';
import Loader from '../../../generic/Loader';
import Table from '../../../generic/Table';
import Button from '../../../generic/Button';

const NFETable = inject('nfsStore')(observer(props => {
  const { nfsStore } = props
  const { isFetching } = nfsStore.state
  const tableHeaders = ['Número da Nota', '']
  const tableRows = nfsStore.orderedFiles.map(data => {
    const xmlNumber = data.Key.split('/')
    const xmlName = xmlNumber[xmlNumber.length - 1].split('.')[0]
    const buttonData = {
      text: 'Download',
      type: 'Button',
      onClick: () => nfsStore.downloadNfs(data.Key, xmlName),
      styleClass: 'is-success',
      isLoading: data.isDownloading
    }
    const viewButton = {
      text: 'Visualizar',
      type: 'Button',
      styleClass: 'is-info',
      onClick: () => {
        nfsStore.setSelectedXml(data.Key)
        nfsStore.getNfeBody()
      },
      isLoading: data.isViewing
    }
    const downloadButton = (
      <div className='buttons'>
        <Button fieldData={buttonData}/><Button fieldData={viewButton}/>
      </div>
    )
    return [xmlName, downloadButton]
  })
  return (
    <Loader isLoading={isFetching}>
      <Table headers={tableHeaders} rows={tableRows}/>
    </Loader>
  )
}))

export default NFETable



// WEBPACK FOOTER //
// ./src/components/dashboard/products/4nfs/NFSTable.js